/**
 * NotFound — 404 error page.
 *
 * Per J-X8: branded page with "Page not found"; "Return home" CTA;
 * secondary "Contact support" link (per J-X6).
 *
 * Cross-cutting invariants:
 *   - Inv 12: no console.log
 *   - Inv 13: no `any`
 *   - Inv 14: internal navigation via <Button onClick={navigate}> for Return home;
 *             external mailto via <Link href="mailto:...">
 *   - Inv 15: atoms from @/components/ui barrel only (Button, Eyebrow, Heading, Link)
 */
import type { ReactElement } from 'react';
import { Button, Eyebrow, Heading, Link } from '@/components/ui';
import { ErrorPageChrome } from './ErrorPageChrome.tsx';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage(): ReactElement {
  const navigate = useNavigate();
  return (
    <ErrorPageChrome>
      <Eyebrow>404 Not Found</Eyebrow>
      <Heading level="h1" className="mt-6">
        Page not found.
      </Heading>
      <p className="mt-4 font-sans text-body-lg text-muted">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center">
        <Button
          variant="primary"
          onClick={() => { void navigate('/'); }}
        >
          Return home
        </Button>
        <Link href="mailto:support@bimassess.com">
          Contact support
        </Link>
      </div>
    </ErrorPageChrome>
  );
}
